import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { WatchlistContext } from '../../contextStore/WatchlistContext';
import { getProductRef } from '../../firebase/collections';
import { useHistory } from 'react-router-dom';
import { PostContext } from '../../contextStore/PostContext';
import { CardSkeleton } from '../UI/Skeleton';
import WatchlistCard from './WatchlistCard';
import './Watchlist.css';

function WatchlistPage() {
  const { t } = useTranslation();
  const { watchlist, removeFromWatchlist } = useContext(WatchlistContext);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const { setPostContent } = useContext(PostContext);

  useEffect(() => {
    if (watchlist.length === 0) {
      setProducts([]);
      setLoading(false);
      return;
    }
    const promises = watchlist.map((e) =>
      getProductRef(e.productId)
        .get()
        .then((snap) =>
          snap.exists ? { ...snap.data(), id: snap.id, _entry: e } : null
        )
    );
    Promise.all(promises).then((list) => {
      setProducts(list.filter(Boolean));
      setLoading(false);
    });
  }, [watchlist]);

  const goToAd = (p) => {
    if (setPostContent) setPostContent(p);
    history.push('/view');
  };

  return (
    <div className="profilePage">
      <div className="watchlistPage">
        <h2>{t('watchlist.priceDropAlerts')}</h2>
        <p style={{ margin: '0 0 20px 0', color: '#666' }}>
          {t('watchlist.notifyWhenPriceDropsTarget')}
        </p>
        {loading ? (
          <div className="watchlistGrid">
            {[1, 2, 3, 4].map((i) => (
              <CardSkeleton key={i} />
            ))}
          </div>
        ) : products.length === 0 ? (
          <p className="emptyState">
            {t('watchlist.noItemsInWatchlist')}
          </p>
        ) : (
          <div className="watchlistGrid">
            {products.map((p) => {
              const entry =
                p._entry || watchlist.find((e) => e.productId === p.id);
              const alertPrice = entry?.alertPrice ?? 0;
              return (
                <WatchlistCard
                  key={p.id}
                  product={p}
                  alertPrice={alertPrice}
                  onView={() => goToAd(p)}
                  onRemove={() => removeFromWatchlist(p.id)}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default WatchlistPage;
